import { FC } from 'react';
import styled from 'styled-components';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import intersectionWith from 'lodash/intersectionWith';
import classNames from 'classnames';
import { LCDD } from '../shared/LCDD';
import { QuickSearchInput } from './QuickSearchInput';
import { GenreOut } from '../../../store/apiLibx';
import { useTranslation } from 'react-i18next';

const StQuickSearchContainer = styled.li`
    position: absolute;
    margin: -2px;
    cursor: inherit;
    top: 0;
    padding: 2px !important;
    width: 100%;
`;

const StNoMatchesFoundContainer = styled.li``;

const StLCDD = styled(LCDD)`
    font-size: 11px;

    .dropdown-list-inner {
        font-size: 12px;
        margin-top: 30px;
    }
`;

interface Props {
    fetchGenres: (e: string) => void;
    addGenre: (genre: GenreOut) => void;
    genres: GenreOut[];
    selectedGenres: GenreOut[];
    disabled: boolean;
}

export const LCGenreDropdownWithSearch: FC<Props> = ({ fetchGenres, genres, selectedGenres, addGenre, disabled }) => {
    const { t } = useTranslation();

    function isGenreEmpty(noGenresFound, standardGenreList) {
        return (
            !noGenresFound &&
            (isEmpty(standardGenreList) ||
                isEqual(standardGenreList, selectedGenres) ||
                isEqual(intersectionWith(standardGenreList, selectedGenres, isEqual), standardGenreList))
        );
    }

    const noGenresFound = isEmpty(genres);
    const noStandardGenreMatchesFound = isGenreEmpty(noGenresFound, genres);

    const noMatchesFoundElement = (
        <StNoMatchesFoundContainer className="cold-grey">
            {t('yourLocalContent.yourTitles.warnings.noMatchesFound')}
        </StNoMatchesFoundContainer>
    );

    const dropdownLabel = (
        <span>
            <i className="strong">+&nbsp;</i>&nbsp;{t('yourLocalContent.yourTitles.addGenre')}
        </span>
    );

    const dropdownClasses = classNames('dropdown-lc lc-input dropdown-bordered with-quicksearch lc-genre-dropdown');
    const buttonClasses = classNames('green-fill', { disabled });

    return (
        <>
            <StLCDD
                preventCloseDropdown={true}
                onOpenListener={() => fetchGenres('')}
                label={dropdownLabel}
                className={dropdownClasses}
                buttonClassname={buttonClasses}
            >
                <ul>
                    <StQuickSearchContainer>
                        <QuickSearchInput onSearch={fetchGenres} />
                    </StQuickSearchContainer>
                    {noGenresFound || noStandardGenreMatchesFound ? noMatchesFoundElement : null}
                    {genres
                        .filter(x => selectedGenres?.find(y => y.id === x.id) === undefined)
                        .map(x => (
                            <li
                                key={x.id}
                                onClick={event => {
                                    event.stopPropagation();
                                    addGenre(x);
                                }}
                            >
                                <i className="strong">+&nbsp;</i>&nbsp;{x.name}
                            </li>
                        ))}
                </ul>
            </StLCDD>
            <div style={{ clear: 'both' }} />
        </>
    );
};
